import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Mail, ArrowLeft } from 'lucide-react';
import './ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await api.post('/company/auth/password-reset/request/', {
                email: email.trim().toLowerCase()
            });
            setSubmitted(true);
        } catch (err: any) {
            setError(err.response?.data?.error || 'Erro ao enviar solicitação. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="forgot-password-page">
                <div className="forgot-password-container">
                    <div className="forgot-password-image-panel">
                        <img
                            src="/agendainicioGold.png"
                            alt="Y-Agenda"
                            className="forgot-password-hero-image"
                        />
                    </div>

                    <div className="forgot-password-form-panel">
                        <div className="forgot-password-form-wrapper">
                            <div className="forgot-password-brand-header">
                                <h1 className="forgot-password-brand-title">Y-Agenda</h1>
                                <p className="forgot-password-brand-subtitle">Gestão inteligente de agendamentos</p>
                            </div>
                            <div className="success-icon-container">
                                <Mail size={48} className="success-icon" />
                            </div>
                            <div className="forgot-password-form-header">
                                <h2>E-mail enviado!</h2>
                                <p>
                                    Se o e-mail estiver cadastrado, você receberá um link de recuperação em breve.
                                </p>
                                <p className="text-muted small">
                                    Verifique sua caixa de entrada e spam. O link é válido por 1 hora.
                                </p>
                            </div>
                            <Link to="/login" className="btn btn-primary btn-lg w-100">
                                <ArrowLeft size={18} className="me-2" />
                                Voltar para o login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-container">
                <div className="forgot-password-image-panel">
                    <img
                        src="/agendainicioGold.png"
                        alt="Y-Agenda"
                        className="forgot-password-hero-image"
                    />
                </div>

                <div className="forgot-password-form-panel">
                    <div className="forgot-password-form-wrapper">
                        <div className="forgot-password-brand-header">
                            <h1 className="forgot-password-brand-title">Y-Agenda</h1>
                            <p className="forgot-password-brand-subtitle">Gestão inteligente de agendamentos</p>
                        </div>
                        <div className="forgot-password-form-header">
                            <h2>Recuperar Senha</h2>
                            <p>Digite seu e-mail para receber um link de recuperação</p>
                        </div>

                        {error && (
                            <Alert variant="danger" className="mb-4">
                                {error}
                            </Alert>
                        )}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-4" controlId="formEmail">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="seu@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                            </Form.Group>

                            <div className="d-grid">
                                <Button
                                    variant="primary"
                                    type="submit"
                                    size="lg"
                                    disabled={loading}
                                    className="btn-primary"
                                >
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Enviando...
                                        </>
                                    ) : (
                                        'Enviar link de recuperação'
                                    )}
                                </Button>
                            </div>
                        </Form>

                        <div className="text-center mt-4">
                            <Link to="/login" className="back-link">
                                <ArrowLeft size={18} className="me-1" />
                                Voltar para o login
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
